import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { ModalContext } from '@/utils/contexts/ModalContext';

import styles from '@/views/components/Modal/ModalDelete.module.scss';

const ModalDeleteChange = () => {
	const { dict } = useSelector((state) => state.app);
	const { closeModal, setModalAdditionalInfo } = useContext(ModalContext);

	const deleteChange = () => {
		setModalAdditionalInfo(info=> {
			return({...info, changeDeleteConfirmed: 'true'});
		});
	};

	return (
		<div className={ 'modal__content modal__delete-file' } >
			<div className={ styles['delete'] } >
				<h1>{dict.letter.popover.deleteChange}</h1>

				<div className={ styles['delete--comment'] }>
					<p>{dict.letter.popover.confirmDeleteChange}</p>
				</div>

				<section className={ styles['delete--buttons'] }>
					<div className={ `button__std` }
						onClick={
							closeModal
						}>
						{dict.cancel}
					</div>
					<div className={ `button__blue` }
						onClick={ deleteChange }>
						{dict.letter.popover.deleteChange}
					</div>
				</section>
			</div>
		</div>
	);
};

export default ModalDeleteChange;